
class FormRuleHelper {


    /**
     *
     * @param {*} v
     * @returns {Array}
     */
    static requireRule(v) {
        return [
            v => !!v || 'Campo richiesto'
        ];
    }



    /**
     *
     * @param {string} v
     * @param {null|boolean} required
     * @param {null|int} min_length
     * @param {null|int} max_length
     * @returns {Array}
     */
    static stringRule(v, required = null, min_length = null, max_length = null) {

        let validate_array = [];
        if(required === true) {
            validate_array.push(v => !!v || 'Campo richiesto');
        }

        if(v !== undefined && v!== null) {

            if(min_length !== null) {
                validate_array.push( v => v.length >= min_length || "Il campo dev'essere composto da almeno "+ min_length + " caratteri");

            }

            if(max_length !== null) {
                validate_array.push( v => v.length <= max_length || "Il campo non può essere composto da più di "+ max_length + " caratteri");
            }

        }


        return validate_array;
    }



    /**
     *
     * @param {int|float} v
     * @param {null|boolean} required
     * @param {null|int|float} min_value
     * @param {null|int|float} max_value
     * @returns {Array}
     */
    static numericRule(v, required = null, min_value = null, max_value = null) {

        let validate_array = [];
        if(required === true) {
            validate_array.push(v => !!v || 'Campo richiesto');
        }

        if(min_value !== null) {
            validate_array.push( v => v >= min_value || "Il campo dev'essere >= di "+ min_value);

        }

        if(max_value !== null) {
            validate_array.push( v => v <= max_value || "Il campo dev'essere <= di "+ max_value);
        }


        return validate_array;

    }

    static booleanRule(v, required = null, expected_value) {
        let validate_array = [];
        if(required === true) {
            validate_array.push(v => !!v || 'Campo richiesto');
        }

        if(v !== undefined && v!== null) {
            validate_array.push( v => v == expected_value || "Il campo dev'essere uguale al valore atteso "+ expected_value);

        }

    }
}


export default FormRuleHelper;
